import { apiGet } from './client';
import type {
  Paginated,
  PlatformOrgListItem,
  PlatformOrgDetail,
  PlatformUserItem,
  PlatformMetrics,
} from '@/types/platform';

export function getPlatformMetrics(): Promise<{ data: PlatformMetrics }> {
  return apiGet<{ data: PlatformMetrics }>('/platform/metrics');
}

export function getPlatformOrganizations(params: {
  page?: number;
  per_page?: number;
  search?: string;
  plan?: string;
  status?: string;
}): Promise<Paginated<PlatformOrgListItem>> {
  return apiGet<Paginated<PlatformOrgListItem>>('/platform/organizations', params);
}

export function getPlatformOrganization(id: string): Promise<{ data: PlatformOrgDetail }> {
  return apiGet<{ data: PlatformOrgDetail }>(`/platform/organizations/${id}`);
}

export function getPlatformUsers(params: {
  page?: number;
  per_page?: number;
  search?: string;
  role?: string;
}): Promise<Paginated<PlatformUserItem>> {
  return apiGet<Paginated<PlatformUserItem>>('/platform/users', params);
}
